import {
  UseInfiniteQueryOptions,
  UseQueryOptions,
  useInfiniteQuery,
  useQuery,
} from "react-query";
import { getBlogCategoriesReq, getBlogReq, getListBlogReq } from "./request";
import {
  IBlog,
  ICategory,
  IGetBlogReq,
  IGetListBlogParams,
  IGetListBlogRes,
} from "./types";

export const useListBlogCategories = (
  option?: UseQueryOptions<ICategory[], Error>
) => {
  return useQuery<ICategory[], Error>(
    "list-blog-categories",
    getBlogCategoriesReq,
    option
  );
};

export const useListBlog = (
  filter: IGetListBlogParams,
  option?: UseInfiniteQueryOptions<IGetListBlogRes, Error>
) => {
  return useInfiniteQuery<IGetListBlogRes, Error>(
    ["list-blog", filter],
    () => getListBlogReq(filter),
    option
  );
};

export const useBlog = (
  params: IGetBlogReq,
  option?: UseQueryOptions<IBlog, Error>
) => {
  return useQuery<IBlog, Error>(
    ["blog", params],
    () => getBlogReq(params),
    option
  );
};
